import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import LoadingArea from "../../components/LoadingArea";
import axios from "../../services/axios";
import saveLog from "../../services/saveLog";
import XTable from "../../components/XTable";
import isConsultant from "../../services/isConsultant";

import { Pagination } from "antd";
import ReactLoading from "react-loading";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import useRole from "../../hooks/useRole";
import { checkPermission } from "../../utils/checkPermission";

import { DatePicker } from "antd";
import exportFromJSON from "export-from-json";
import moment from "moment";
import { DownloadOutlined } from "@ant-design/icons";
import { message } from "antd";

const { RangePicker } = DatePicker;

function Logs() {
  const [load, setLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);
  const [errorCodeList, setErrorCodeList] = useState([]);
  const [errorCode, setErrorCode] = useState("");

  const [current, setCurrent] = useState(1);
  const [description, setDescription] = useState();
  const [defaultDate, setDefaultDate] = useState([]);
  const { csvData, setCsvData } = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [canViewLogs, setCanViewLogs] = useState(false);
  const [canDownloadLogs, setCanDownloadLogs] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const [viewAllowed, downloadAllowed] = await Promise.all([
        checkPermission(userRole, "logs_module", "view_logs"),
        checkPermission(userRole, "logs_module", "download_logs"),
      ]);
      setCanViewLogs(viewAllowed);
      setCanDownloadLogs(downloadAllowed);
    } catch (error) {
      console.error("Permission check failed for Logs Module:", error);
    }
  };

  //CSV DATA
  const exportType = "csv";
  let fileName = `OTP_Logs_Status_${moment(new Date()).format(
    "DD-MM-YYYY_HH:mm"
  )}`;

  const toggle = (description) => {
    if (description !== "cancel") {
      setDescription(description);
    } else {
      setDescription("");
    }
    setModal(!modal);
  };

  const onChange = (page) => {
    setCurrent(page);
  };

  useEffect(() => {
    if (errorCode) {
      fetchLogs("App", searchTerm);
    } else {
      message.warning("Please Select Log Type", 2);
    }
    fetchErrorCode();
  }, [current, errorCode, defaultDate]);

  useEffect(() => {
    if (userRole) {
      checkPermissions();
    }
  }, [userRole]);

  async function fetchLogs(action, searchText) {
    console.log("inside fubnction", searchTerm);
    if (errorCode && defaultDate) {
      setLoad(true);
      try {
        const response = await axios.post(
          `/logs/logList?PageNo=${current}&PageSize=10&StartDate=${
            defaultDate[0]
              ? defaultDate[0]
              : moment(new Date()).format("YYYY-MM-DD")
          }&EndDate=${
            defaultDate[1]
              ? defaultDate[1]
              : moment(new Date()).format("YYYY-MM-DD")
          }`,
          {
            logName: errorCode,
            searchData: searchText,
            dataType: action,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          }
        );
        if (action === "Bulk") {
          setLoad(false);
          if (response.data.logData.length > 0) {
            console.log("resssssssssssssssss", response.data.logData);
            const data = response?.data?.logData.map((ele) => {
              return {
                _id: ele._id,
                name: ele.name,
                user: ele.user,
                createdAt: ele.createdAt,
                updatedAt: ele.updatedAt,
                description: ele.description ? JSON.parse(ele.description) : "",
              };
            });
            console.log("final data", data);
            exportFromJSON({ data, fileName, exportType });
          } else {
            message.warning("No Data Available", 2);
          }
        } else {
          setFilteredLogs(response.data);
        }

        setLoad(false);
      } catch (e) {}
    } else {
      message.warning("Please Select Log Type", 2);
    }
  }

  async function fetchErrorCode() {
    const list = await axios.get(
      `/errorCode`,

      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      }
    );
    console.log(list.data.errorCode);
    setErrorCodeList(list.data.errorCode);
  }

  function truncateText(text = "none", maxLength) {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    } else {
      return text;
    }
  }

  const [typingTimeout, setTypingTimeout] = useState(0);

  const handleSearch = (event) => {
    const searchText = event.target.value;
    setSearchTerm(searchText);
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    setTypingTimeout(
      setTimeout(() => {
        fetchLogs("App", searchText);
      }, 500)
    );
  };

  const disabledDate = (current) => {
    // 90 DAYS GAP AND DISABLE TOMORROW
    return (
      current.isBefore(moment().subtract(90, "day")) ||
      current > moment().endOf("day")
    );
  };

  //DATE FILTER
  const handleDate = (value, dateString) => {
    if (value === null) {
      setCurrent(1);
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ]);
    } else {
      setCurrent(1);
      setDefaultDate(dateString);
    }
  };

  if (!canViewLogs) {
    return <div></div>;
  }

  return (
    <div>
    {!isConsultant() && <Dashboard title="Logs">
      <LoadingArea isLoading={loading}>
        {/* <div className="row p-3 border mb-2 bg-white cursor-pointer"> */}
        <div className="row bg-white cursor-pointer p-3 border mb-2 d-flex align-items-center">
          <div className="col-md-3">
            <div className="">
              <select
                id="FormType"
                className="mb-2 form-control"
                onChange={(e) => {
                  setErrorCode(e.target.value);
                }}
                value={errorCode}
              >
                <option value="" selected="true">
                  Log Type
                </option>
                {errorCodeList &&
                  errorCodeList?.map((obj) => {
                    return (
                      <option
                        //selected
                        value={obj.errorCodeName}
                      >
                        {obj.errorCodeName}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
          <div className="col-md-3">
            <RangePicker
              className=""
              format="YYYY-MM-DD"
              defaultValue={[moment(), moment()]}
              onChange={handleDate}
              // onOk={onOk}
              disabledDate={disabledDate}
              placeholder={[
                moment(new Date()).format("YYYY-MM-DD"),
                moment(new Date()).format("YYYY-MM-DD"),
              ]}
            />
          </div>
          <div className="col-md-3">
            <input
              className="form-control"
              type="text"
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
          <div className="col-md-3 d-flex justify-content-end">
            <div className="">
              {canDownloadLogs && (
                <button
                  className="btn btn-primary btn-block "
                  onClick={() => {
                    fetchLogs("Bulk", searchTerm);
                  }}
                >
                  <i class="fa fa-download" aria-hidden="true"></i>
                </button>
              )}
            </div>
          </div>
        </div>
        {/* </div> */}
        <div className="card-body row p-3 border mb-2 bg-white cursor-pointer">
          <table className="table bg-white ">
            <thead>
              <tr>
                <th>Name</th>
                <th>user</th>
                {/* <th>ip</th> */}
                <th>description</th>
                <th>createdAt</th>
              </tr>
            </thead>
            <tbody>
              {filteredLogs.logData?.map((ele) => {
                return (
                  <tr>
                    <td>{ele.name}</td>
                    <td>{ele.user}</td>
                    {/* <td>{ele.ip}</td> */}
                    {ele?.description?.length > 0 ? (
                      <td
                        style={{ color: "#0081C9" }}
                        onClick={() => toggle(ele?.description)}
                      >
                        {truncateText(ele?.description, 30)}
                      </td>
                    ) : (
                      <td style={{ color: "red" }}>none</td>
                    )}
                    <td>{ele.createdAt}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <Pagination
            current={current}
            onChange={onChange}
            total={filteredLogs.totalLogs}
          />
        </div>
        <Modal isOpen={modal} toggle={() => toggle("cancel")}>
          <ModalHeader toggle={() => toggle("cancel")}>
            Log description
          </ModalHeader>
          <ModalBody>
            <div style={{ width: "100%", wordWrap: "anywhere" }}>
              <p>{description}</p>
            </div>
          </ModalBody>
          <ModalFooter>
            {/* <Button color="primary" >
              Update
            </Button>{" "}
            <Button color="secondary" onClick={() => toggle("cancel")}>
              Cancel
            </Button> */}
          </ModalFooter>
        </Modal>
      </LoadingArea>
    </Dashboard>}
    </div>
  );
}

export default Logs;
